import { useState } from "react";

export function useTripHoveredPlace() {
  const [hoveredPlaceIndex, setHoveredPlaceIndex] = useState<
    number | undefined
  >(undefined);
  return { hoveredPlaceIndex, setHoveredPlaceIndex };
}
